/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S6_Item2Inputs */

const tr_cerez_s6_item2 = /** @type {(inputs: Cerez_S6_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcı ayarlarından çerezleri silme veya engelleme`)
};

const en_cerez_s6_item2 = /** @type {(inputs: Cerez_S6_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting or blocking cookies in your browser settings`)
};

const de_cerez_s6_item2 = /** @type {(inputs: Cerez_S6_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen oder Blockieren von Cookies in den Browsereinstellungen`)
};

const ru_cerez_s6_item2 = /** @type {(inputs: Cerez_S6_Item2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление или блокировка файлов cookie в настройках браузера`)
};

/**
* | output |
* | --- |
* | "Deleting or blocking cookies in your browser settings" |
*
* @param {Cerez_S6_Item2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s6_item2 = /** @type {((inputs?: Cerez_S6_Item2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S6_Item2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s6_item2(inputs)
	if (locale === "de") return de_cerez_s6_item2(inputs)
	if (locale === "ru") return ru_cerez_s6_item2(inputs)
	return tr_cerez_s6_item2(inputs)
});